//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  -- Constants ----------------------
export const handleCreateUserPreference = (userId,data) => {
    return async (dispatch) => {
        dispatch(ActivityActions.createUserPreference());
        try {
            const response = await apis.post('userPreferenceRDS', '/userPreference', {
                body: {
                    userId,
                    ...data
                }
            });
            if(response&&response.id){
                dispatch(ActivityActions.createUserPreferencSuccess(response));
            }
           return response;
        } catch (error) {
            if(error&&error.message!="Network Error"){
                logToSentry({
                message: 'creating user preference',
                error,
                module: 'USER_PREFERENCE',
                operation: 'CREATE_USER_PREFERENCE'
            });
             }
            dispatch(ActivityActions.createUserPreferenceFail(error));
        }
    }
}
export const handleUpdateUserPreference = (userId, data) => {
    return async (dispatch) => {
        dispatch(ActivityActions.updatePreferenceUser());
        try {
            const response = await apis.put('userPreferenceRDS', `/userPreference/${userId}`, {
                body: {
                    ...data
                }
            });
            if(response&&response.id){
                dispatch(ActivityActions.updateUserPreferenceSuccess(response));
            }
           return response;
        } catch (error) {
            if(error&&error.message!="Network Error"){
                logToSentry({
                message: 'updating user preference',
                error,
                module: 'USER_PREFERENCE',
                operation: 'UPDATE_USER_PREFERENCE'
            });
             }
            dispatch(ActivityActions.updateUserPreferenceFail(error));
        }
    }
}
export const handleGetUserPreference = (userId) => {
    return async (dispatch) => {
        dispatch(ActivityActions.getUserPreference());
        try {
            let response;
            response = await apis.get('userPreferenceRDS', `/userPreference/${userId}`);
            if(!response){
                response = {
                    order_by_date: "due_date",
                    orderBy: "desc"
                }
            }
            dispatch(ActivityActions.getUserPreferenceSuccess(response));
            return response;
        } catch (error) {
            if(error&&error.message!="Network Error"){
                logToSentry({
                message: 'getting user preference',
                error,
                module: 'USER_PREFERENCE',
                operation: 'GET_USER_PREFERENCE'
            });
             }
            dispatch(ActivityActions.getUserPreferenceFail(error));
            return error;
        }
    }
}

export const handleGetStudentUserPreference = (teacherId, classId) => {
    return async (dispatch) => {
        dispatch(ActivityActions.getUserPreference());
        try {
            let response;
             response = await apis.post('userPreferenceRDS', `/studentUserPreference`, {
                body: {
                    teacherId,
                    classId
                }
            });
            if(!response){
                response = {
                    order_by_date: "due_date",
                    orderBy: "desc"
                }
            }
            dispatch(ActivityActions.getUserPreferenceSuccess(response));
            return response;
        } catch (error) {
            if (error && error.message != "Network Error") {
                logToSentry({
                message: 'getting student user preference',
                error,
                module: 'USER_PREFERENCE',
                operation: 'GET_STUDENT_USER_PREFERENCE'
            });
            }
            dispatch(ActivityActions.getUserPreferenceFail(error));
            return error;
        }
    }
}
export const handleLogAuthFailure = async(username, reason , integration) => {
   try {
    return apis.post('userPreferenceRDS', `/auth-fail-log`, {
        body: {
            username,
            reason,
            integration
        }
    });
   } catch (error) {
    if(error&&error.message!="Network Error"){
        logToSentry({
                message: 'logging auth failure',
                error,
                module: 'USER_PREFERENCE',
                operation: 'LIST_ACTIVITY_FEEDBACK'
            });
     }
   }
}
export const handleVerifyAuth = async(username, reason , integration) => {
   return apis.post('userPreferenceRDS', `/verify-auth`, {
    body: {
        username,
        integration
    }
   });
}